import { LitElement, html, css } from 'lit';
import { accessibility, formStyles, dialog, details, grid } from '../../utilities/styles';
import { validateForm, decodeEntities, checkFormLock, releaseFormLock, lockForm, validateURL, releaseFormLockwithBeacon } from '../../utilities/formsUtilities';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { AllInOrganisationConsumer } from '../Utilities/AllInOrganisationConsumer';
import { eyeSvg, deleteIcon, expandIcon, collapseIcon } from '../../utilities/icons';
import { hideRevealPassword } from '../../utilities/formsUtilities';
import { AllInSessionStorage } from '../Utilities/AllInSessionStorage';
import { AllInIntegrationsBase } from '../Utilities/AllInIntegrationsBase';
import { handle403s } from '../../utilities/AllInErrorHandling';
export class AllInMemberIntegrationForm extends AllInIntegrationsBase(AllInSessionStorage(AllInOrganisationConsumer(LitElement))) {
    static properties = {
        currentOrg: { type: String, reflect: true },
        _isFormLocked: { state: true, type: Boolean },
        _membersError: { state: true, type: String },
        _formHasValues: { state: true, type: Boolean },
        loading: { state: true, type: Boolean },
    };
    constructor() {
        super();
    }
    get _form() {
        return this.shadowRoot.querySelector('form');
    }
    get _modal() {
        return this.shadowRoot.querySelector('dialog');
    }
    async connectedCallback() {
        super.connectedCallback();
        if (this.providerConfig) {
            this.formID = `organisation_member_integration_${this.currentOrg}`;
        }
        this.uid = `integration-member-form-${this.organisationData.user.id}`;
        this.renderRoot.querySelector('a')?.focus();
        if (!this.memberProvisions || !this.memberProvisions.length) {
            this._getMembershipProvisionsFromSessionStorage();
            if (!this.memberProvisions || !this.memberProvisions.length) {
                this._getMembershipProvisions();
            }
        }
        this.eventManager.listen(`allin-event-go-back-${this.name}`, this._handleGoBackFromNav);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.eventManager.disconnect();
        releaseFormLock(this.formID, this.uid, this.restUrl, this.nonce);
    }
    async firstUpdated() {
        if (this.formID) {
            this._isFormLocked = await checkFormLock(this.formID, this.uid, this.restUrl, this.nonce);
            addEventListener('visibilitychange', (event) => {
                if (document.visibilityState === 'hidden') {
                    releaseFormLockwithBeacon(this.formID, this.uid, this.restUrl, this.nonce);
                }
            });
        }
    }
    async updated(changedProperties) {
    }
    render() {
        let main = '';
        if (this.loading || !Object.keys(this.providerConfig).length) {
            main = html `<allin-loader loading></allin-loader>`;
        }
        else if (this.view == 'success') {
            main = html `\n                <div class="form_container">\n                    <h2>Success! Your members provisions are now mapped to your ticketing provider.</h2>\n                    <p>Profiles that are shared with you will now begin to sync with your ticketing provider.</p>\n                    <button class="button" @click=${(e) => { return this._updateContext({ dashboard: '', panel: '', view: '' }); }}>Return to dashboard</button>\n                </div>\n            `;
        }
        else {
            if (!this.memberProvisions?.length) {
                if (this._membersError) {
                    main = html `<div class="message error"><p>Something is wrong with the ticketing provider details you have provided. Please check they are correct and try again</p></div>\n                        <button class="button" @click=${() => { this._updateContext({ dashboard: 'integrations', panel: 'ticketing-provider-configuration' }); }}>Retry</button>\n                    `;
                }
                else {
                    main = html `<allin-loader loading></allin-loader>`;
                }
            }
            else {
                let currentMapping = this.providerConfigMapping;
                if (!currentMapping) {
                    currentMapping = this._getSessionStorageItem(`event_preview_formdata_${this.currentOrg}`);
                    if (currentMapping) {
                        currentMapping = JSON.parse(currentMapping);
                    }
                    else {
                        currentMapping = {};
                    }
                }
                else {
                    let _currentMappingRemapped = {};
                    if (currentMapping.providerAttributes) {
                        currentMapping.providerAttributes.forEach((attr) => {
                            if (attr.entity == 'MemberProfile') {
                                _currentMappingRemapped['member_' + attr.standardId] = attr.providerCode;
                            }
                        });
                    }
                    currentMapping = _currentMappingRemapped;
                }
                let provisionsLoop = [];
                provisionsLoop = this.memberProvisions.map((item) => {
                    let markup = [];
                    item.provisions.forEach((provision) => {
                        let description = 'This needs to match the attribute code from your provider exactly';
                        let title = `Map to your attributes`;
                        if (this.providerConfig?.provider == 'SpektrixV3') {
                            description = 'This needs to match your corresponding Spektrix tag exactly';
                            title = `Map to your tags`;
                        }
                        markup.push(html `\n                            <div class="provision item grid">\n                                <div class="text">\n                                    <p><strong>${provision.name}</strong></p>\n                                </div>\n                                <div class="mapping">\n                                    <label for="member_${provision.id}">${title}</label>\n                                    <p class="small">${description}</p>\n                                    <input name="member_${provision.id}" id="member_${provision.id}" type="text" data-label="Map to your attributes" data-table_label="Map to your attributes" value="${currentMapping ? currentMapping['member_' + provision.id] || '' : ''}" />\n                                </div>\n                            </div>\n                        `);
                    });
                    if (markup.length == 0) {
                        return '';
                    }
                    let icon = item.title.toLowerCase().replace(/\s+/g, '_').replace(/[^\w]/g, '') + '.svg';
                    return html `\n                        <details class="provisions">\n                            <summary><img src="/wp-content/themes/ace/assets/icons/purple/${icon}" alt="Icon representing ${item.title}" @error=${(e) => { if (e.target.src !== "/wp-content/themes/ace/assets/icons/purple/default_provision.svg") {
                        e.target.src = '/wp-content/themes/ace/assets/icons/purple/default_provision.svg';
                    } }} />${item.title}</summary>\n                            <div class="panel">\n                                ${markup}\n                            </div>\n                        </details>\n                    `;
                });
                let hasProvisions = provisionsLoop.filter((item) => item != '');
                let provisionsPre = '';
                if (hasProvisions.length) {
                    provisionsPre = html `<div class="collapsers">\n                        <button class="expand_all" @click=${this._expandCollapseAll}>${expandIcon}Expand all</button>\n                        <button class="collapse_all" @click=${this._expandCollapseAll}>${collapseIcon}Collapse all</button>\n                    </div>`;
                }
                main = html `\n                    <div class="${this.subview == 'preview' ? 'hide' : ''} form_container">\n                        <p>${unsafeHTML(this.integration_panels?.integrations_member_intro_text)}</p>\n                        <h2>Map your member data</h2>\n                        <form @submit=${this._handleSubmitMapping} class="bg">\n                            <div class="message notice" aria-live="polite">\n                            </div>\n                            ${hasProvisions.length ? html `\n                                <h3>Map your provisions</h3>\n                            ` : ''}\n                            <p>${unsafeHTML(this.integration_panels?.integrations_member_mapping_text)}</p>\n                            ${provisionsPre}\n                            ${provisionsLoop}\n                            <input type="submit" class="button" value="Submit this mapping" />\n                            <input type="hidden" name="org_id" value="${this.currentOrg}" />\n                            <input type="hidden" name="action" value="submit-member-mapping" />\n                        </form>\n                    </div>\n                `;
            }
        }
        return html `${main}`;
    }
    _handleClick(e) {
        e.preventDefault();
        this.panel = '';
        this.view = '';
        let crumb = {
            organisation: { url: `/organisation-dashboard/${this.currentOrg}/`, title: `${this.organisation?.name} Dashboard` },
            dashboard: { url: `/organisation-dashboard/${this.currentOrg}/`, title: `Integrations` }
        };
        this.eventManager.emit(`allin-breadcrumb-${this.name}`, crumb);
        this.eventManager.addHistory('/organisation-dashboard/' + this.currentOrg + '/integrations', { panel: '', view: '' });
        this.eventManager.emit(`allin-organisation-${this.name}-switcher`, { dashboard: 'integrations', panel: ``, view: '' });
        this.partial = false;
    }
    _getOrganisationById(id) {
        return this.organisations.find((org) => org.org_id == id);
    }
    _validateURL(e) {
        if (e.target.type !== 'url')
            return;
        validateURL(e.target);
    }
    async _handleSubmitMapping(e) {
        e.preventDefault();
        let formResponse = this._form.querySelector('.message');
        formResponse.innerHTML = '';
        formResponse.classList.remove('error');
        let valid = validateForm(this._form, formResponse);
        if (!valid) {
            formResponse.scrollIntoView();
            return;
        }
        let formData = new FormData(this._form);
        this._form.classList.add('loading');
        this._form.setAttribute('aria-busy', 'true');
        try {
            let response = await fetch(this.restUrl, {
                method: 'POST',
                body: formData,
                headers: {
                    'AllIn-Nonce': this.nonce,
                }
            });
            if (response.status === 403) {
                handle403s();
                return;
            }
            response = await response.json();
            if (response.ok) {
                this._form.classList.remove('loading');
                this._form.setAttribute('aria-busy', 'false');
                this.providerConfigMapping = response.mapping;
                this.providerConfig.mapping = response.mapping;
                this.view = 'success';
                this.organisation.integration_config = this.providerConfig;
                this._updateContext({ view: this.view, organisation: this.organisation, providerConfig: this.providerConfig, providerConfigMapping: this.providerConfigMapping });
                this.eventManager.emit(`allin-navigation-reset-${this.name}`, {});
            }
            else {
                formResponse.innerHTML = response.message;
                formResponse.classList.add('error');
                this._form.classList.remove('loading');
                this._form.setAttribute('aria-busy', 'false');
            }
        }
        catch (error) {
            console.error('Error:', error);
            formResponse.innerHTML = 'Something went wrong';
            formResponse.classList.add('error');
            this._form.classList.remove('loading');
            this._form.setAttribute('aria-busy', 'false');
        }
        ;
    }
    async _getMembershipProvisions() {
        let url = `${this.restUrl}?org_id=${this.currentOrg}&action=${this.action}-provisions-membership-all&nonce=${this.nonce}`;
        try {
            const response = await fetch(url, {
                headers: {
                    'AllIn-Nonce': this.nonce,
                }
            });
            if (response.status === 403) {
                handle403s();
                return;
            }
            const data = await response.json();
            this.memberProvisions = data.provisions;
            this._setMembershipProvisionsToSessionStorage();
            this.eventManager.emit(`allin-organisation-${this.name}-update`, { memberProvisions: JSON.stringify(this.memberProvisions) });
        }
        catch (error) {
            console.error('Error:', error);
        }
    }
    _expandCollapseAll(e) {
        e.preventDefault();
        let targets = this.shadowRoot.querySelectorAll('.provisions');
        if (e.currentTarget.classList.contains('expand_all')) {
            targets.forEach(target => {
                target.setAttribute('open', '');
            });
        }
        else {
            targets.forEach(target => {
                target.removeAttribute('open');
            });
        }
    }
    _handleGoBackFromNav() {
        this.subview = '';
        this.eventManager.emit(`allin-navigation-reset-${this.name}`, {});
        this._updateContext({ subview: this.subview });
    }
    static styles = [
        accessibility,
        formStyles,
        dialog,
        details,
        grid,
        css `
        allin-greeting{
            --allin-font-size: 2rem;
            --allin-font-weight: 700;
        }
        .bg{
            padding:var(--allin-padding,2rem);
            background-color:var(--allin-bg-color,#ccc);
            margin-bottom:0.5rem;
        }
        .bg a{
            font-size:0.9rem;
            text-decoration:none;
            font-weight:700;
            color:var(--allin-highlight-color,#472961);
            display:flex;
            align-items:center;
            gap:0.5rem;
        }

        .bg a:hover{
            text-decoration:underline;
        }



        .small{
            font-size:0.875rem;
        }

        fieldset{
            border:0;
            padding:0;
            margin:0;
        }

        legend{
            font-size:1.25rem;
            font-weight:700;
            margin-bottom:1rem;
            color:var(--allin-highlight-color,#472961);
        }
        legend:has(+p){
            margin-bottom:0.5rem;
        }

        .button-group{
            display:flex;
            justify-content:space-between;
            margin-top:2rem;
        }
        
       
        .border-top{
            border-top:1px solid var(--allin-highlight-color,#472961);
            padding-top:2rem;
        }
        .button-group button:not([type="submit"]), .return{
            background-color:transparent;
            color:var(--allin-highlight-color,#472961);
            border:0;
            display:flex;
            gap:0.5rem;
            align-items:center;
            text-decoration:underline;
            cursor:pointer;
            transition:color var(--transition) ease;
            font-weight:700;
            font-size:1rem;

        }
        .return{
            padding:0;
            margin-bottom:2rem;
        }

        .button-group button svg, .return svg{
            transition:transform var(--transition) ease;
        }
        .button-group button:hover, .return:hover{
            text-decoration-thickness:2px;
        }
        
        .button-group button:hover svg, .return:hover svg{
            transform:rotate(15deg);
        }
        @media (prefers-reduced-motion: reduce) {

            .button-group button:hover svg, .return:hover svg{
                transform:none;
            }
        }
        table{
            width:100%;
            border-collapse:collapse;
        }

        td{
            padding-bottom:2rem;
            word-break:break-all;
        }

        td:first-child:not(.duet-date__cell){
            width:42%;
            padding-right:2rem;
            vertical-align:top;
        }

        td:last-child{
            width:58%;
            font-weight:600;
            vertical-align:top;
        }
        
        td svg{
            height:0.5rem;
        }

        hr{
            border:0;
            border-top:1px solid var(--allin-highlight-color,#472961);
            margin-top:2rem;
            margin-bottom:2rem;
        }
        allin-image-uploader img[src='']{
            display:none;
        }

        allin-image-uploader img {
            width: 100px;
            height: 100px;
            object-fit: contain;
            object-position: left;
        }

        .collapse div{
            overflow:hidden;
            max-height:0;
            transition:max-height var(--transition) ease;
        }
        .collapse td{
            padding-bottom:0
            transition:all var(--transition) ease;
            border-bottom:1px solid transparent;
        }

        .collapse.open div{
            max-height:1000px;
        }

        .collapse.open td{
            padding-bottom:1rem;
            border-bottom-color:var(--allin-highlight-color,#472961);
        }

        .flex{
            display:flex;
            justify-content:space-between;
            align-items:center;
        }

        .flex button{
            background-color:transparent;
            border:0;
            cursor:pointer;
        }

        .buttons{
            display:flex;
            justify-content:flex-start;
            gap:1rem;
            margin-bottom:2rem;
        }

        .buttons button{
            background-color:#fff;
            color:var(--allin-highlight-color,#472961);
            border:1px solid var(--allin-highlight-color,#472961);
            padding:0.5rem 1rem;
            cursor:pointer;
            transition:background-color var(--transition) ease, color var(--transition) ease;
            font-size:1rem;
            font-weight: var(--allin-button-font-weight, 600);
        }

        .buttons button.active, .buttons button:hover{
                background-color: var(--color-secondary-lighter-to-primary-lighter, #d3c9d7);
                font-weight: var(--allin-button-font-weight, 600);
                color: #343434;
        }

        .buttons button.active{
            cursor:default;
        }

        td button svg:last-child{
            display:none;
        }

        td button svg:last-child path{
            fill:var(--allin-highlight-color,#472961);
        }

        td button[aria-expanded="true"] svg:first-child{
            display:none
        }
        
        td button[aria-expanded="true"] svg:last-child{
            display:inline-block;
        }

        .image_description img{
            object-fit:contain;
            object-position:top left;
        }

        .provision allin-tooltip {

            width: 100%;
            padding-left: 1.9rem;
            margin-top: 0.5rem;
        }

        .provision .hidden {
            display: none;
            max-height:0;
            overflow:hidden;
            transition:all var(--transition) ease;
            transition-behavior: allow-discrete;
            padding:0.5rem 1rem 0.5rem 1rem;
            width:100%;

        }

        .provision .hidden label textarea{
            margin-top:0.5rem;
        }

        .provision:has(>.hidden){
            border-bottom: 1px solid var(--allin-highlight-color,#472961);
            padding:1rem 0;
            margin:0 0 1rem;
        }
    
        .provision .input-group:has(:checked)~.hidden {
            display: block;
            max-height:700px;
            box-sizing: border-box;
            overflow:visible;
        }

        .provision {
            padding-bottom: 1rem;
            margin-bottom: 1rem;
            border-bottom: 2px solid var(--allin-highlight-color,#472961);
            gap:0.5rem;
        }

        .provision:last-child {
            border-bottom: none;
            margin-bottom: 0;
            padding-bottom: 0;
        }

        allin-image-uploader img {
            width: 100px;
            height: 100px;
            object-fit: contain;
            object-position: left;
        }
        allin-image-uploader img,allin-image-uploader input{
            margin:0.5rem 0;
        }

        .image-uploader:has(img[src='']){
            display:none;
        }
        .image-uploader ~ input[type='file']{
            display:none;
        }
        .image-uploader:has(img[src='']) ~ input[type='file']{
            display:block;
        }

        .image-uploader {
            display: flex;
            align-items: start;
            gap: 1rem;
        }
        
        .image-uploader button {
            background-color: transparent;
            margin-top: 0.5rem;
            padding: 0;
        }
        
        .image-uploader button svg path {
            fill: black;
        }

        allin-image-uploader{
            overflow:hidden;
        }
        allin-image-uploader ::file-selector-button{
            display:block;
            background-color:var(--allin-highlight-color,#472961);
            color:#fff; 
            padding:0.5rem 1rem;
            border:none;
            border-radius:0.5rem;
            cursor:pointer;
            text-align:center;
            font-size:1rem;
            font-weight:bold;
            transition:background-color var(--transition) ease;
            width:max-content;
        }

        allin-image-uploader ::file-selector-button:hover{
            background-color:var(--allin-highlight-color,#472961);
        }
        .add_uploader{
            background-color: var(--allin-button-bg-color, #472961);
            color: #fff;
            margin-bottom: 1.5rem;
        }
        .add_uploader span svg {
            background-color: #fff;
            transform: translate(0px, 3px);
        }

        .add_uploader:hover span svg {
            background-color: transparent;
        }
        
        allin-multiloader .group .button_secondary{
            background-color: transparent;
            color: var(--allin-button-bg-color, #472961);
            display:none
        }

        allin-multiloader .group:has(.image-uploader img[src=""]) .button_secondary{
            display: block;
        }

        .image-uploader ~ input[type='file']{
            background-color: transparent !important;
        }
        .grid--icon{
            grid-template-columns: 1.6rem 1fr;
            gap:1.5rem;
        }
        @media screen and (min-width:700px){
            .grid--image{
                grid-template-columns: 200px 1fr;
                gap:3rem;
            }
        }
        .item{
            margin-bottom:1rem;
            width:100%;
        }

        .item p{
            margin-bottom:0.2rem;
        }
        .provisions{
            background-color:#fff;
            border-radius:0.4rem;
            border:1px solid #707070;
            padding:0;
            margin-bottom:1rem;
                container-type: normal;
        }
        .provisions summary{
            padding:1rem 3rem 1rem 1rem;
            margin:0;
            font-size:1.25rem;
            font-size:clamp(1.25rem, 5cqw, 1.5rem);
            font-weight:700;
            color:var(--allin-highlight-color,#472961);
            cursor:pointer;
            display: grid;
            grid-template-columns: 1.5rem 1fr;
            align-items: center;
            gap: 1.5rem;
        }
        .provisions.no-image summary{
            grid-template-columns: 1fr;
        }
        .provisions summary::after{
            right:1rem;
            top:1.2rem;
        }
        .provisions .panel{
            padding:0.5rem 1rem;
        }
        input:read-only:not([type=submit]) {
            background-color: #fff;
        }
        .provisions img{
            object-fit:contain;
            object-position:top left;
        }
        .provisions summary img{
            object-fit:contain;
            object-position:top left;
            width:24px;
        }
        .collapsers{
            margin-left:auto;
            margin-bottom:1rem;
            display: flex;
            flex-wrap: wrap;
            gap: 1rem;
            width: fit-content;
        }
        .collapsers button{
            background-color: transparent;
            color: var(--allin-highlight-color,#472961);
            border: 0;
            cursor: pointer;
            font-weight: 700;
            font-size: 1rem;
            display: flex;
            align-items: center;
            gap: 0.5rem;
        }
         .listbox-area {
            
            padding: 20px;
            border: 1px solid #aaa;
            border-radius: 4px;
            background: #eee;
        }
        @media screen and (min-width:700px){
            .listbox-area {
                display: grid;
                grid-gap: 2em;
                grid-template-columns: repeat(2, 1fr);
            }
        }
        [role="listbox"] {
            margin: 1em 0 0;
            padding: 0;
            min-height: 18em;
            border: 1px solid #aaa;
            background: white;
        }

        [role="listbox"]#ss_elem_list {
            position: relative;
            max-height: 18em;
            overflow-y: auto;
        }

        [role="listbox"] + *,
        .listbox-label + * {
            margin-top: 1em;
        }

        [role="group"] {
            margin: 0;
            padding: 0;
        }

        [role="group"] > [role="presentation"] {
            display: block;
            margin: 0;
            padding: 0 0.5em;
            font-weight: bold;
            line-height: 2;
            background-color: #ccc;
        }

        [role="option"] {
            position: relative;
            display: block;
            margin: 2px;
            padding: 2px 1em 2px 1.5em;
            line-height: 1.8em;
            cursor: pointer;
        }

        [role="listbox"]:focus [role="option"].focused {
            background: #bde4ff;
        }

        [role="listbox"]:focus [role="option"].focused,
        [role="option"]:hover {
            outline: 2px solid currentcolor;
        }

        .move-right-btn span.checkmark::after {
            content: " →";
        }

        .move-left-btn span.checkmark::before {
            content: "← ";
        }

        [role="option"][aria-selected="true"] span.checkmark::before {
            position: absolute;
            left: 0.5em;
            content: "✓";
        }

        button[aria-haspopup="listbox"] {
            position: relative;
            padding: 5px 10px;
            width: 150px;
            border-radius: 0;
            text-align: left;
        }

        button[aria-haspopup="listbox"]::after {
            position: absolute;
            right: 5px;
            top: 10px;
            width: 0;
            height: 0;
            border: 8px solid transparent;
            border-top-color: currentcolor;
            border-bottom: 0;
            content: "";
        }

        button[aria-haspopup="listbox"][aria-expanded="true"]::after {
            position: absolute;
            right: 5px;
            top: 10px;
            width: 0;
            height: 0;
            border: 8px solid transparent;
            border-top: 0;
            border-bottom-color: currentcolor;
            content: "";
        }

        button[aria-haspopup="listbox"] + [role="listbox"] {
            position: absolute;
            margin: 0;
            width: 9.5em;
            max-height: 10em;
            border-top: 0;
            overflow-y: auto;
        }

        [role="toolbar"] {
            display: flex;
        }

        [role="toolbar"] > * {
            border: 1px solid #aaa;
            background: #ccc;
        }

        [role="toolbar"] > [aria-disabled="false"]:focus {
            background-color: #eee;
        }

        button {
            font-size: inherit;
        }

        button[aria-disabled="true"] {
            opacity: 0.5;
        }

        .annotate {
            color: #366ed4;
            font-style: italic;
        }

        .hidden {
            display: none;
        }

        .offscreen {
            position: absolute;
            width: 1px;
            height: 1px;
            overflow: hidden;
            clip: rect(1px 1px 1px 1px);
            clip: rect(1px, 1px, 1px, 1px);
            font-size: 14px;
            white-space: nowrap;
        }
        @media screen and (min-width:700){
            allin-multiloader .input-group{
                display:grid;
                grid-template-columns: 1fr 2fr;
                grid-template-rows: auto auto auto;
                column-gap:2rem;
                margin-bottom:2rem;
            }
        }
        allin-multiloader .group{
            display:none;
        }

        allin-multiloader .group.show{
            display:block;
        }
        allin-multiloader .input-group allin-image-uploader{
            grid-column: 1 / 2;
            grid-row: 1 / -1;
        }

        allin-multiloader allin-image-uploader .image-uploader{
            display:block;

        }

        allin-multiloader allin-image-uploader .image-uploader button{
            background-color: #fff;
            border-radius: 0.5rem;
            padding: 0.5rem 1rem;
            border: 1px solid var(--allin-highlight-color,#472961);
            color: var(--allin-highlight-color,#472961);
        }

        allin-multiloader allin-image-uploader .image-uploader button:hover{
            background-color: var(--allin-highlight-color,#472961);
            color: #fff;
        }

        .instances{
            padding:0;
            margin:0;
            list-style:none;
        }

        .instances li:not(:last-child){
            margin-bottom:1rem;
            padding-bottom:1rem;
            border-bottom:1px solid var(--allin-highlight-color,#472961);
        }

        .instances dl{
            display:grid;
            grid-template-columns: max-content 1fr;
            gap:1rem;
        }

        .instances dl dt{
            font-weight:500;
        }
        
        dd h4{
            margin:0 0 0.5rem 0;
        }

        dd p{
            margin-bottom:1rem;
        }
        p:has(+.provisions){
            grid-column: 1 / -1;
            margin-top:2rem;
            margin-bottom:0;
        }
        .repeater{
            padding:0 2rem;
        }
        
        @media (min-width: 700px) {
            .show-password {
                top: calc(100% + 0.5rem)!important;
            }
        }
        .form_container{
            margin-top:2rem;
        }
        `
    ];
}
